function validateEmailOnly(validate_status){
     var customer_email = jQuery("#RecoverEmail"); 
     var validate_status = validate_status;
     var ctaCheckEm = ctaCheckEmail(customer_email.val());
     //console.log(ctaCheckEm);
     if(customer_email.val() == '' || ctaCheckEm == false ){
       validate_status = 1;
       var validate_message ='<span class="email-error error">Please enter Email Address</span>';    
       
       if(customer_email.val() == ''){
         validate_message ='<span class="email-error error">Please enter Email Address</span>';    
       }else if(ctaCheckEm == false){
         validate_message ='<span class="email-error error">Please enter a valid Email Address</span>';    
       }
             
       customer_email.css({"border": "2px solid red"});
       jQuery(".error").remove();
       jQuery("#RecoverEmail").closest('.field').append(validate_message);
       
     }
      
     if(validate_status == 1){
        return 1;  
      }else{
        return 0;
      } 
} 

function validateEmailAndPassword(validate_status, page){
  var validate_status = validate_status;
  var customer_email = jQuery("#RegisterForm-email");
  var customer_password = jQuery("#RegisterForm-password");
  if(page == 'login'){
    customer_email = jQuery("#CustomerEmail");
    customer_password = jQuery("#CustomerPassword");
  }
     
     
     var ctaCheckEm = ctaCheckEmail(customer_email.val());
     if(customer_email.val() == '' || ctaCheckEm == false ){
       validate_status = 1;
       var validate_message ='<span class="email-error error">Please enter Email Address</span>';    
       
       if(customer_email.val() == ''){
         validate_message ='<span class="email-error error">Please enter Email Address</span>';    
       }else if(ctaCheckEm == false){
         validate_message ='<span class="email-error error">Please enter a valid Email Address</span>';    
       }
             
       customer_email.css({"border": "2px solid red"});
       customer_email.closest('.field').children(".error").remove();
       customer_email.closest('.field').append(validate_message);
       
     }else{
       customer_email.css({"border": "1px solid rgba(179, 179, 179, 1)"});
       customer_email.closest('.field').children(".error").remove();
     }
     if(customer_password.val() == ''){
       var pwd_validate_message ='<span class="password-error error">Password is required</span>';    
       validate_status = 1;
       customer_password.css({"border": "2px solid red"});
       customer_password.closest('.field').children(".error").remove();
       customer_password.closest('.field').append(pwd_validate_message);
     }else{
       customer_password.closest('.field').children(".error").remove();
       customer_password.css({"border": "1px solid rgba(179, 179, 179, 1)"});
     }
      if(validate_status == 1){
        return 1;  
      }else{
        return 0;
      }
}

function passwordOnly(validate_status){
    var validate_status = validate_status;
    var customer_password = jQuery("#password");
    var customer_confirm_password = jQuery("#password_confirmation");

    if(customer_password.val() == ''){
       var pwd_validate_message ='<span class="password-error error">Password is required</span>';    
       validate_status = 1;
       customer_password.css({"border": "2px solid red"});
       customer_password.closest('.field').children(".error").remove();
       customer_password.closest('.field').append(pwd_validate_message);
     }else{
       customer_password.closest('.field').children(".error").remove();
       customer_password.css({"border": "1px solid rgba(179, 179, 179, 1)"});
     }
     if(customer_confirm_password.val() == ''){
       var pwd_validate_message ='<span class="password-error error">Confirm password is required</span>';    
       validate_status = 1;
       customer_confirm_password.css({"border": "2px solid red"});
       customer_confirm_password.closest('.field').children(".error").remove();
       customer_confirm_password.closest('.field').append(pwd_validate_message);
     }else{
       customer_confirm_password.closest('.field').children(".error").remove();
       customer_confirm_password.css({"border": "1px solid rgba(179, 179, 179, 1)"});
     } 
  
     if(validate_status == 1){
        return 1;  
      }else{
        return 0;
      } 
} 

function ctaCheckEmail(ctaEmail) {
           var ctaRegex =/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
           if (!ctaRegex.test(ctaEmail)) {
               return false;
           }
           else {
              return true;
           }
}